import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from "redux-persist";
import storage from "redux-persist/lib/storage/session"; // sessionStorage
import applicationReducer from "./application/applicationSlice";
import featureFlagsReducer from "./feature-flags/featureFlagsSlice";

// Persist configuration for application
const applicationPersistConfig = {
    key: "application",
    version: 1,
    storage,
    // Only persist specific fields, exclude loading states
    whitelist: [
        "offerData",
        "quoteData",
        "contactData",
        "paymentInformationData",
        "needsReview",
        "isContactDataComplete",
        "isPaymentInformationComplete",
        "currentStep",
        "sessionId",
        "saveContId",
        "isResumedApplication",
        "saveContSessionCreatedFired",
        "giwlHydratedParamsKey",
        "isApplicationSubmitted",
    ],
};

// Persist configuration for featureFlags
const featureFlagsPersistConfig = {
    key: "featureFlags",
    version: 1,
    storage,
    // Only persist flags, exclude loading states and errors
    whitelist: ["flags"],
};

// Create persisted reducers
const persistedApplicationReducer = persistReducer(applicationPersistConfig, applicationReducer);
const persistedFeatureFlagsReducer = persistReducer(featureFlagsPersistConfig, featureFlagsReducer);

export const store = configureStore({
    reducer: {
        application: persistedApplicationReducer,
        featureFlags: persistedFeatureFlagsReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                // Ignore redux-persist actions
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
